"use strict";
/**
 * Represents a key-value pair configuration.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigKeys = void 0;
var ConfigKeys;
(function (ConfigKeys) {
    ConfigKeys["Currency"] = "currency";
    ConfigKeys["WelcomeMessage"] = "welcome_message";
})(ConfigKeys || (exports.ConfigKeys = ConfigKeys = {}));
